import Raven from 'raven-js';
import { renderRoot } from 'quartz-core/client';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { useRef } from 'react';
import { Route, BrowserRouter as Router, useHistory } from 'react-router-dom';
import { NavMarker, RhumbProvider } from 'react-rhumb';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import { useSyncIFrameHeightInsideFrame } from 'embedded-academy-lib/insideFrame';
import { DataFetchingClientProvider } from 'academy-common-lib/utils/DataFetchingClient';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import rhumbConfig from '../rhumb-config.yaml';
import dataFetchingClient from './utils/DataFetchingClient';
import { ErrorBoundary } from './features/error';
import { usageTracker } from './utils/usageTracker';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import { getPublicLang } from 'academy-common-lib/utils/url';
import { StaticContentResult } from './features/staticContentWidget';
import UIApplication from 'UIComponents/app/UIApplication';
import { jsx as _jsx } from "react/jsx-runtime";
usageTracker.setProperties({
  screen: 'static_content_widget_public',
  hostAppName: new URLSearchParams(window.location.search).get('parentAppName')
});
const StaticPublicContentWidget = () => {
  const history = useHistory();
  const ref = useRef(null);
  const {
    isReady
  } = useSyncIFrameHeightInsideFrame(ref);
  return /*#__PURE__*/_jsx(UIApplication, {
    name: "embedded-academy-ui",
    children: /*#__PURE__*/_jsx(RhumbProvider
    // @ts-expect-error the config isn't well typed so we're just going to ignore it
    , {
      config: rhumbConfig,
      history: historyAdapter(history),
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
          client: dataFetchingClient,
          children: /*#__PURE__*/_jsx(NavMarker, {
            name: "STATIC_PUBLIC_WIDGET_PAGE_LOADED",
            children: /*#__PURE__*/_jsx("div", {
              ref: ref,
              style: {
                overflow: 'hidden'
              },
              children: /*#__PURE__*/_jsx(StaticContentResult, {
                isResizeReady: isReady
              })
            })
          })
        })
      })
    })
  });
};
class StaticApplication {
  start() {
    const locale = getPublicLang();
    const I18nProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    I18nProvider.setLocale({
      locale,
      langEnabled: true
    });
    Raven.setUserContext({
      // @ts-expect-error we don't have access to all data required by Raven types
      locale
    });
    Promise.all([initAppTranslations([I18nProvider.register(lang), registerAllData(I18nProvider)])]).then(() => {
      renderRoot( /*#__PURE__*/_jsx(UIApplication, {
        name: "embedded-academy-ui",
        children: /*#__PURE__*/_jsx(Router, {
          basename: '/embedded-academy-ui',
          children: /*#__PURE__*/_jsx(Route, {
            path: "/static",
            children: /*#__PURE__*/_jsx(StaticPublicContentWidget, {})
          })
        })
      }));
    }).then(() => {
      /**
       * The embedded academy library will pass params via post message as it's a easier to pass whatever data
       * we need and we expect to receive data back via post message too.
       * This is simply a way to allow the health checks to work and enable easier testing of the widget in isolation
       */
      const searchParams = new URLSearchParams(window.location.search);
      const contentId = searchParams.get('contentId');
      const language = searchParams.get('language');
      const lessonId = searchParams.get('lessonId');
      const shortId = searchParams.get('shortId');
      const variant = searchParams.get('variant');
      const startTime = searchParams.get('startTime');
      if (shortId || lessonId && contentId && language) {
        window.postMessage({
          type: 'embeddedAcademy:staticPublic:staticState',
          message: {
            contentId,
            language,
            lessonId,
            shortId,
            variant,
            startTime,
            authType: 'public'
          }
        }, window.location.origin);
      }
    }).catch(error => {
      Raven.captureException(error);
    });
  }
}
new StaticApplication().start();